import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { refineFonts } from '@/Theming/refineFonts';
import { DowntimeMobileIcon } from '@icons/DowntimeMobileIcon';
import NavBarComponent from './NavBar/NavBar';
import { useContext } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { DowntimeDesktopIcon } from '@icons/DowntimeDesktopIcon';

const { xLargeBold, largeRegular } = refineFonts;

export const DowntimeScreen = () => {
	const { languageCode } = useContext(LocalizationContext);
	const theme = useTheme();
	const greaterThanSmall = useMediaQuery(theme.breakpoints.up('sm'));

	const downtimeScreenTitle: any = {
		'en-US': 'Please check back soon',
		'es-ES': 'Por favor, revise luego',
	};

	const downtimeScreenMessage: any = {
		'en-US':
			'This module is currently undergoing maintenance and should be up shortly. If the issue persists, please contact your local branch or our call center for assistance.',
		'es-ES':
			'Este módulo se encuentra actualmente en mantenimiento y debería estar disponible en breve. Si el problema persiste, comuníquese con su sucursal local o con nuestro centro de llamadas para obtener ayuda.',
	};

	return (
		<Stack height={'100%'} width={'100%'}>
			<NavBarComponent isQuestionTrailDisplayed={false} showLanguageSelector={true} />
			<Stack
				paddingInline={{
					xxs: '24px',
					xs: '24px',
					sm: '48px',
					md: '105px',
					lg: '350px',
					xl: '403px',
				}}
				paddingTop={{
					xxs: '32px',
					xs: '32px',
					sm: '8%',
					md: '8%',
					lg: '8%',
					xl: '8%',
				}}
				height={'100%'}
				justifyContent={'center'}
				alignItems={'center'}>
				{greaterThanSmall ? <DowntimeDesktopIcon /> : <DowntimeMobileIcon />}

				<Typography textAlign={'center'} sx={{ ...xLargeBold }}>
					{downtimeScreenTitle[languageCode]}
				</Typography>
				<Typography textAlign={'center'} sx={{ ...largeRegular }}>
					{downtimeScreenMessage[languageCode]}
				</Typography>
			</Stack>
		</Stack>
	);
};
